import { useCallback } from 'react';
import type React from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { LazyComponent, ScrollableComponent } from '#src/app/shared/components/layout/lazy';

import { ContributeSectionSkeleton } from '../skeletons';

export const LazyContributeSection: React.FC = () => {
	const loadComponent = useCallback(
		async () =>
			(await import(/* webpackChunkName: "cmp/homepage_contribute_section" */ '../ContributeSection'))
				.ContributeSection,
		[],
	);

	return (
		<ClientRender placeholder={<ContributeSectionSkeleton />}>
			<ScrollableComponent topOffset={200} immediateForBots fallback={<ContributeSectionSkeleton />}>
				<LazyComponent loadComponent={loadComponent} fallback={<ContributeSectionSkeleton />} />
			</ScrollableComponent>
		</ClientRender>
	);
};
